"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function default_1({ queryClient, roomId, liked, }) {
    queryClient.setQueriesData(['roomsData'], data => data && Object.assign(Object.assign({}, data), { pages: data.pages.map(page => (Object.assign(Object.assign({}, page), { result: page.result.map(room => {
                if (room.id === roomId) {
                    if (typeof room.like_counts === 'number') {
                        const prevLikeCounts = room.like_counts || 0;
                        const likeCounts = liked
                            ? prevLikeCounts + 1
                            : prevLikeCounts === 0
                                ? 0
                                : prevLikeCounts - 1;
                        return Object.assign(Object.assign({}, room), { has_like: liked, like_counts: likeCounts });
                    }
                    else
                        return Object.assign(Object.assign({}, room), { has_like: liked });
                }
                else
                    return room;
            }) }))) }));
}
exports.default = default_1;
